import React from "react";
import strings from "assets/strings";
import { objectTypeProps } from 'types';
import Text from "components/text/Text";
import { checkIfParamExist } from "helpers";
import { algoliaAttributes } from "assets/constants";
import { aroundRadiusOptions } from "assets/constants";
import styles from "./MedicalCenterRefinements.module.scss";
import { RefinementListProps } from "components/dropdown/Dropdown";
import { CustomDropdown } from "components/customDropdown/CustomDropdown";
import { CustomCheckboxes } from "components/buttons/customCheckboxes/CustomCheckboxes";
import { VirtualRefinementList } from "components/virtualRefinement/VirtualRefinmentList";
import { DropdownLocalAlgoliaWithSearch } from "components/dropdownLocalAlgoliaWithSearch/DropdownLocalAlgoliaWithSearch";


const queryString = window.location.search;
const urlSearchParams = new URLSearchParams(queryString);


const sortByTimeOfDay: RefinementListProps['sortBy'] = (a, b) => {
  const order: Record<string, number> = {
    "morning": 1,
    "noon": 2,
    "evening": 3
  };
  return order[a.name.toLocaleLowerCase()] - order[b.name.toLocaleLowerCase()];
};


const transformItems = (items: any[]) => {
  return items.map((item) => ({
    ...item,
    label:
      item.label === "Morning"
        ? strings.globalStrings.morning
        : item.label === "Noon"
          ? strings.globalStrings.noon
          : item.label === "Evening"
            ? strings.globalStrings.evening
            : item.label,
  }));
};

export const MedicalCenterRefinements = (props: objectTypeProps) => {
  const { objectType } = props;
  return (
    <div className={styles.container}>
      <aside className={styles.aside}>
        <Text
          className={styles.title}
          text={strings.globalStrings.filterBy}
        />

        {!checkIfParamExist('loc') && <DropdownLocalAlgoliaWithSearch
          attribute={algoliaAttributes.PlaceCity}
          title={strings.globalStrings.city}
        />
        }
          {checkIfParamExist('loc') && !checkIfParamExist('cityCode') && <CustomDropdown
          selectOptions={aroundRadiusOptions}
          title={strings.globalStrings.distance}
          slectedValue={urlSearchParams.has("r") ? Number(urlSearchParams.get("r")) : 20000}
          defaultValue={20000}
        />}
        {/*original code*/}
        {checkIfParamExist('loc') && checkIfParamExist('cityCode') && <CustomDropdown
          selectOptions={aroundRadiusOptions}
          title={strings.globalStrings.distance}
          slectedValue={urlSearchParams.has("r") && Number(urlSearchParams.get("r")) !== 20000 ? Number(urlSearchParams.get("r")) : 20000}
          defaultValue={20000}
        />}

           {/*original code
        {checkIfParamExist('loc') && <CustomDropdown
          selectOptions={aroundRadiusOptions}
          title={strings.globalStrings.distance}
          slectedValue={urlSearchParams.has("r") && Number(urlSearchParams.get("r")) !== 10000 ? Number(urlSearchParams.get("r")) : 10000}
          defaultValue={10000}
        />}*/}

       

        <DropdownLocalAlgoliaWithSearch
          attribute="name"
          title={strings.medicalCentersSearchResults.searchByName}
        />
        {/* <CustomSearch
          attribute="name"
          title={strings.medicalCentersSearchResults.searchByName}
          marginTop={20}
        /> */}

        { objectType !== 9 && <CustomCheckboxes
          isFlex
          sortBy={["name:asc"]}
          title={strings.globalStrings.visitDays}
          attribute="workingHours.dayOfWeek"
        />
        }
        {objectType !== 9 && <CustomCheckboxes
          title={strings.globalStrings.visitHours}
          attribute="workingHours.timeOfDay"
          transformItems={(items) => transformItems(items)}
          sortBy={sortByTimeOfDay}
        />
        }
        {(objectType == 6) && <VirtualRefinementList          
          attribute="workingHours.dayOfWeek"
          />
        } 

        {(objectType == 9) && 
        <DropdownLocalAlgoliaWithSearch

        attribute={algoliaAttributes.MedicalServices}
        title={strings.medicalCentersSearchResults.chooseService}

      />
        // <DropdownLocalAlgolia
        //   hideContinueBtn
        //   attribute={algoliaAttributes.MedicalServices}
        //   title={strings.medicalCentersSearchResults.servicesInClinic}
        //   titlePopup={strings.medicalCentersSearchResults.chooseService}
        //   subTitlePopUp={strings.medicalCentersSearchResults.canChooseService}
        // />
        }
      </aside>
    </div>
  );
};
